import { tools } from './tools';

class Dom {
    constructor() {}

    /**
     * Adding values from Opus objects to the dom.
     * (some fake templating)
     * @param {TimeSlot} timeSlot
     * @param {Clinic} clinic
     * @param {Clinician} clinician
     * @param {Treatment} treatment
     */
    apply(timeSlot, clinic, clinician, treatment) {
        if (timeSlot) {
            $('.hd-timeslottime').html(tools.formatToTime(timeSlot.start));
            $('.hd-timeslotdate').html(tools.formatToDate(timeSlot.start));
            $('.hd-timeslotdateprefix').html(tools.formatToPrefix(timeSlot.start));
            $('.hd-newtimeslottime').html(tools.formatToTime(timeSlot.start));
            $('.hd-newtimeslotdate').html(tools.formatToDate(timeSlot.start));
            $('.hd-newtimeslotdateprefix').html(tools.formatToPrefix(timeSlot.start));
        }

        if (clinic) {
            $('.hd-clinicname').html(clinic.name);
            $('.hd-clinicphone').html(`<a href="tel:${tools.formatPhoneToLink(clinic.work)}">${clinic.work}</a>`);
        }

        if (clinician) {
            $('.hd-clinicianname').html(clinician.name);
        }

        if (treatment) {
            $('.hd-treatmentname').text(treatment.name);
        }
    }

    /**
     * Toggle button spinner and enable/disable button
     * @param {strin} id element id
     * @param {boolean} show show or hide the spinner
     */
    toggleSpinner(id, show) {
        if (show) {
            $(`${id} .spinner-border`).show();

            $(id).addClass('disabled');
        } else {
            $(`${id} .spinner-border`).hide();

            $(id).removeClass('disabled');
        }
    }
}

export let dom = new Dom();



// WEBPACK FOOTER //
// ./scripts/booking/helpers/dom.js